import { connect } from 'react-redux';
import QuestionAnswering from './question-answering';
import {
  loadSingleQuestion,
  selectTest,
  onStartTest,
  onRemoveTestRun,
 } from '../../reducers/test.reducers';

const mapDispatchToProps = dispatch => ({
  loadQuestion: id => dispatch(loadSingleQuestion(id)),
  startNewTestRun: (test) => {
    dispatch(selectTest(test));
    dispatch(onStartTest({ testId: test.id }));
  },
  removeTestRun: runId => dispatch(onRemoveTestRun(runId)),
});

const mapStateToProps = state => ({
  config: state.authentication.config,
  currentQuestion: state.tests.currentQuestion,
  testRun: state.tests.testRun,
});

export default connect(mapStateToProps, mapDispatchToProps)(QuestionAnswering);



// WEBPACK FOOTER //
// ./src/app/components/question_answering/question-answering.container.js